export default __webpack_public_path__ + "static/media/noe-display-bold.ede69b11.ttf";